import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const recentSales = [{
  name: 'Martín L.',
  city: 'CABA',
  time: 'hace 3 minutos'
}, {
  name: 'Camila R.',
  city: 'Córdoba',
  time: 'hace 7 minutos'
}, {
  name: 'Facundo G.',
  city: 'Rosario',
  time: 'hace 12 minutos'
}, {
  name: 'Lucía M.',
  city: 'Mendoza',
  time: 'hace 18 minutos'
}, {
  name: 'Santiago P.',
  city: 'La Plata',
  time: 'hace 25 minutos'
}, {
  name: 'Valentina D.',
  city: 'Tucumán',
  time: 'hace 31 minutos'
}, {
  name: 'Nicolás B.',
  city: 'Mar del Plata',
  time: 'hace 38 minutos'
}, {
  name: 'Florencia S.',
  city: 'Salta',
  time: 'hace 44 minutos'
}, {
  name: 'Tomás A.',
  city: 'Neuquén',
  time: 'hace 52 minutos'
}, {
  name: 'Julieta V.',
  city: 'Bahía Blanca',
  time: 'hace 1 hora'
}];
export function SalesNotification() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const showNotification = useCallback(() => {
    if (dismissed) return;
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 4500);
  }, [dismissed]);
  useEffect(() => {
    // First notification after 8 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 8000);
    return () => clearTimeout(initialTimeout);
  }, [showNotification]);
  useEffect(() => {
    if (dismissed) return;
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % recentSales.length);
      showNotification();
    }, 20000);
    return () => clearInterval(interval);
  }, [dismissed, showNotification]);
  const sale = recentSales[currentIndex];
  return <AnimatePresence data-id="element-160">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      x: -80,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -80
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-4 left-4 z-50 max-w-xs" data-id="element-161">
          <div className="bg-white rounded-xl shadow-lg border border-warm-border p-4 flex items-start gap-3 relative" data-id="element-162">
            <button onClick={() => setDismissed(true)} className="absolute top-2 right-2 text-text-secondary/40 hover:text-text-secondary text-xs leading-none p-1" aria-label="Cerrar" data-id="element-163">
              ✕
            </button>

            <div className="shrink-0 w-10 h-10 rounded-full bg-accent-teal/10 flex items-center justify-center" data-id="element-164">
              <ShoppingBag className="w-5 h-5 text-accent-teal" data-id="element-165" />
            </div>

            <div className="pr-4" data-id="element-166">
              <p className="text-sm font-medium text-text-primary leading-snug" data-id="element-167">
                {sale.name}{' '}
                <span className="font-normal text-text-secondary" data-id="element-168">
                  de {sale.city}
                </span>
              </p>
              <p className="text-sm text-text-secondary mt-0.5" data-id="element-169">
                compró{' '}
                <span className="font-medium text-accent-teal" data-id="element-170">
                  Monotributista en Calma
                </span>
              </p>
              <p className="text-xs text-text-secondary/60 mt-1" data-id="element-171">{sale.time}</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}